export const copyToClipboard = async (text = '') => {
  if (!navigator?.clipboard) {
    console.warn('Clipboard API is not supported');
    return false;
  }

  try {
    await navigator.clipboard.writeText(text);

    return true;
  } catch (error) {
    console.error('Failed to copy text:', error);
    return false;
  }
};
